export default __webpack_public_path__ + "static/media/success.e1ec99e1.svg";